import React, {useEffect, useRef} from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import logo from '../assets/logo_patos.png';

export const DialogDashboard = ({ visible, setVisible, pedras, pedraPesquisa }) => {
    const cssText = `
    #print-content {
        font-family: 'Open Sans', sans-serif;
        width: 100%;
        textAlign: center;
        float: left;
        display: block;
    }

    #header-img {
        margin-right: 250px;
    }

    #legenda {
        margin-left: 180px;
    }

    img {
        margin-top: 25px;
        width: 100%;
        max-width: 250px;
        height: auto;
        display: block;
        }

    .header-img {
        display: flex;
        justify-content: center;
    }

    .header {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .header h2 {
        margin-bottom: 0px;
    }

    .header h4 {
        margin-top: 7px;
    }

    #conjuntoPedras {
        float: left;
        display: block;
        margin: 0 0 2px 0;
        padding: 0 0 0 0;
    }

    #espacoPedras{
        float: left;
        display: block;
        margin: -5px 0 5px 0;
        padding: 0 0 0 0;
        border: 1px solid white;
    }
    `

    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    const numeroBodyTemplate = (rowData) => {
        return (
            <>
                <div className="col-12 md:col-4" id="conjuntoPedras">
                    {rowData.uso ?
                        <>
                            {parseInt(rowData.numero) <= 84 ?
                                <>
                                    {parseInt(rowData.numero) % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid black',
                                            'fontSize': '10px',
                                            'background': 'red',
                                            'fontWeight': 'bold',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': 'black',
                                            'padding': '0px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            id="ocupado"
                                            // className="p-button-success"
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <><br /><br /></>}
                                    {parseInt(rowData.numero) % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid black',
                                            'fontSize': '10px',
                                            'background': 'red',
                                            'fontWeight': 'bold',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 20px -22px',
                                            'color': 'black',
                                            'padding': '0px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            id="ocupado2"
                                            // className="p-button-success"
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <></>}
                                    {parseInt(rowData.numero) === 28 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                    {parseInt(rowData.numero) === 56 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                </>
                                :
                                <></>}
                        </>
                        :
                        <>
                            {parseInt(rowData.numero) <= 84 ?
                                <>
                                    {parseInt(rowData.numero) % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid grey',
                                            'background': 'green',
                                            'fontSize': '10px',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '0px'
                                        }}
                                            id="livre"
                                            // className="p-button-success"
                                            tooltip={parseInt(rowData.numero)}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <><br /><br /></>}
                                    {parseInt(rowData.numero) % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid grey',
                                            'background': 'green',
                                            'fontSize': '10px',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 20px -22px',
                                            'color': "white",
                                            'padding': '0px'
                                        }}
                                            id="livre2"
                                            // className="p-button-success"
                                            tooltip={parseInt(rowData.numero)}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <></>}

                                    {parseInt(rowData.numero) === 28 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                    {parseInt(rowData.numero) === 56 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                </>
                                :
                                <></>}
                        </>
                    }


                </div>



            </>
        );
    }

    const numero2BodyTemplate = (rowData) => {
        return (
            <>
                <div className="col-12 md:col-4" id="conjuntoPedras">
                    {rowData.uso ?
                        <>
                            {parseInt(rowData.numero) >= 85 && parseInt(rowData.numero) <= 168 ?
                                <>

                                    {parseInt(rowData.numero) % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid black',
                                            'fontSize': '10px',
                                            'background': 'red',
                                            'fontWeight': 'bold',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': 'black',
                                            'padding': '0px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            id="ocupado"
                                            // className="p-button-success"
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <><br /><br /></>}
                                    {parseInt(rowData.numero) % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid black',
                                            'fontSize': '10px',
                                            'background': 'red',
                                            'fontWeight': 'bold',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 20px -22px',
                                            'color': 'black',
                                            'padding': '0px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            id="ocupado2"
                                            // className="p-button-success"
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <></>}
                                    {parseInt(rowData.numero) === 112 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                    {parseInt(rowData.numero) === 140 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                </>
                                :
                                <></>}
                        </>
                        :
                        <>
                            {parseInt(rowData.numero) >= 85 && parseInt(rowData.numero) <= 168 ?
                                <>
                                    {parseInt(rowData.numero) % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid grey',
                                            'background': 'green',
                                            'fontSize': '10px',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '0px'
                                        }}
                                            id="livre"
                                            // className="p-button-success"
                                            tooltip={parseInt(rowData.numero)}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <><br /><br /></>}
                                    {parseInt(rowData.numero) % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid grey',
                                            'background': 'green',
                                            'fontSize': '10px',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 20px -22px',
                                            'color': "white",
                                            'padding': '0px'
                                        }}
                                            id="livre2"
                                            // className="p-button-success"
                                            tooltip={parseInt(rowData.numero)}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <></>}

                                    {parseInt(rowData.numero) === 112 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                    {parseInt(rowData.numero) === 140 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                </>
                                :
                                <></>}
                        </>
                    }

                </div>

            </>
        );
    }

    const numero3BodyTemplate = (rowData) => {
        return (
            <>
                <div className="col-12 md:col-4" id="conjuntoPedras">
                    {rowData.uso ?
                        <>
                            {parseInt(rowData.numero) >= 169 && parseInt(rowData.numero) <= 252 ?
                                <>
                                    {parseInt(rowData.numero) % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid black',
                                            'fontSize': '9px',
                                            'background': 'red',
                                            'fontWeight': 'bold',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': 'black',
                                            'padding': '0px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            id="ocupado"
                                            // className="p-button-success"
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <><br /><br /></>}
                                    {parseInt(rowData.numero) % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid black',
                                            'fontSize': '9px',
                                            'background': 'red',
                                            'fontWeight': 'bold',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 20px -22px',
                                            'color': 'black',
                                            'padding': '0px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            id="ocupado"
                                            // className="p-button-success"
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <></>}
                                    {parseInt(rowData.numero) === 196 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                    {parseInt(rowData.numero) === 224 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                </>
                                :
                                <></>}
                        </>
                        :
                        <>
                            {parseInt(rowData.numero) >= 169 && parseInt(rowData.numero) <= 252 ?
                                <>
                                    {parseInt(rowData.numero) % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid grey',
                                            'background': 'green',
                                            'fontSize': '9px',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '0px'
                                        }}
                                            id="livre"
                                            // className="p-button-success"
                                            tooltip={parseInt(rowData.numero)}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <><br /><br /></>}
                                    {parseInt(rowData.numero) % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid grey',
                                            'background': 'green',
                                            'fontSize': '9px',
                                            'width': '21px',
                                            'height': '30px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 20px -22px',
                                            'color': "white",
                                            'padding': '0px'
                                        }}
                                            id="livre"
                                            // className="p-button-success"
                                            tooltip={parseInt(rowData.numero)}
                                            tooltipOptions={{ position: 'top' }}>

                                            {parseInt(rowData.numero)}

                                        </Button>
                                        : <></>}
                                    {parseInt(rowData.numero) === 196 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                    {parseInt(rowData.numero) === 224 ? <div className="p-field p-col-12 p-sm-12" id="espacoPedras"></div> : <></>}
                                </>
                                :
                                <></>}
                        </>
                    }

                </div>
            </>
        );
    }


    const tabelaBodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) <= 19 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="0" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }

    const tabela2BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 20 && parseInt(rowData.numero) <= 38 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="0" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }



    const tabela3BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 39 && parseInt(rowData.numero) <= 57 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }


    const tabela4BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 58 && parseInt(rowData.numero) <= 99 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }


    const tabela5BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 100 && parseInt(rowData.numero) <= 141 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }


    const tabela6BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 142 && parseInt(rowData.numero) <= 183 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }


    const tabela7BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 184 && parseInt(rowData.numero) <= 206 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }

    const tabela8BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 207 && parseInt(rowData.numero) <= 229 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }


    const tabela9BodyTemplate = (rowData) => {
        return (
            <>


                {parseInt(rowData.numero) >= 230 && parseInt(rowData.numero) <= 252 ?
                    <table width="95%" border="1" style={{ 'borderCollapse': 'collapse', 'fontSize': '10px' }} cellPadding="2px" cellSpacing="5px" >
                        <tbody>
                            <tr>
                                <td width="10%" align='center' >{parseInt(rowData.numero)}</td>
                                <td width="90%" align='left' >{rowData.ocupante !== '' ? rowData.ocupante : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                    :
                    <></>}


            </>
        );
    }

    useEffect(() => {


        if (visible) {
                reactToPrintFn();
                setVisible(false);
        }

    }, [visible, setVisible, reactToPrintFn])

    return (
        <div style={{ 'display': 'none'}}>
            {/* {boletins.length > 0 ? */}
            <div id="print-content" ref={contentRef}>
                <div className="p-d-flex p-jc-between header-img">
                    <div id="header-img" style={{ 'margin': '0 0 20px 0' }}>
                        <img style={{ width: 70, height: 70 }}
                            id="logo"
                            alt="Logo"
                            src={logo}
                        />
                    </div>

                    <div className="p-d-flex p-ai-center p-flex-column header" style={{ 'margin': '20px 20% 20px 20%' }}>
                        <h2>Pedras- {new Date(pedraPesquisa.dataEmissao).toLocaleDateString()}</h2>
                    </div>


                    <div id="legenda" style={{ 'margin': '0 0 20px 0' }}>
                        <h4>Legenda:</h4>
                        <Button style={{
                            'border': '1px solid black',
                            'fontSize': '10px',
                            'background': 'red',
                            'fontWeight': 'bold',
                            'height': '32px',
                            'textAlign': 'center',
                            'margin': '1px',
                            'color': "black",
                            'display': 'block',
                            'float': 'left'
                        }}
                            id="ocupado">
                            N° Ocupado
                        </Button>

                        <Button style={{
                            'border': '1px solid grey',
                            'background': 'green',
                            'fontSize': '10px',
                            'height': '32px',
                            'textAlign': 'center',
                            'margin': '1px',
                            'color': 'white',
                            'display': 'block',
                            'float': 'left'
                        }}
                            id="livre">

                            N° Livre

                        </Button>

                        <Button style={{
                            'border': '1px solid black',
                            'fontSize': '10px',
                            'background': 'red',
                            'fontWeight': 'bold',
                            'height': '32px',
                            'textAlign': 'center',
                            'margin': '1px',
                            'color': "black",
                            'display': 'block',
                            'float': 'left',
                            'textDecoration': 'underline'
                        }}
                            id="avulsa">

                            Avulsa

                        </Button>




                    </div>

                </div>
                {/* <div className="p-d-flex p-ai-center p-flex-column header" style={{ 'margin': '0 0 20px 0'}}>
                            <h2>Pedras</h2>

                        </div> */}

                {<>
                    <DataView
                        value={pedras}
                        layout={numeroBodyTemplate}
                        itemTemplate={numeroBodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 0 0 4%', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={numero2BodyTemplate}
                        itemTemplate={numero2BodyTemplate}
                        emptyMessage="Nenhuma pedra encontrada"
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 1% 0 1%', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={numero3BodyTemplate}
                        itemTemplate={numero3BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'padding': '0px' }}
                    >
                    </DataView>






                    <DataView
                        value={pedras}
                        layout={tabelaBodyTemplate}
                        itemTemplate={tabelaBodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 0 0 4%', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={tabela2BodyTemplate}
                        itemTemplate={tabela2BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 1% 0 1%', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={tabela3BodyTemplate}
                        itemTemplate={tabela3BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={tabela4BodyTemplate}
                        itemTemplate={tabela4BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 0 0 4%', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={tabela5BodyTemplate}
                        itemTemplate={tabela5BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 1% 0 1%', 'padding': '0px' }}
                    >
                    </DataView>


                    <DataView
                        value={pedras}
                        layout={tabela6BodyTemplate}
                        itemTemplate={tabela6BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={tabela7BodyTemplate}
                        itemTemplate={tabela7BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 0 0 4%', 'padding': '0px' }}
                    >
                    </DataView>


                    <DataView
                        value={pedras}
                        layout={tabela8BodyTemplate}
                        itemTemplate={tabela8BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'margin': '0 1% 0 1%', 'padding': '0px' }}
                    >
                    </DataView>

                    <DataView
                        value={pedras}
                        layout={tabela9BodyTemplate}
                        itemTemplate={tabela9BodyTemplate}
                        emptyMessage=""
                        id="contPedra"
                        style={{ 'width': '30%', 'float': 'left', 'display': 'block', 'padding': '0px' }}
                    >
                    </DataView>

                </>
                }


            </div>
            {/* :

                    null
                } */}


        </div>
    );
}
